import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { MsalProvider } from '@azure/msal-react';
import { BrowserRouter } from 'react-router-dom';
import { system } from '@denise-augusta/ui';
import { msalInstance } from '@/auth/msal';
import { SiteContentProvider } from '@/providers/SiteContentProvider';
import { App } from './App';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

msalInstance.initialize().then(() => {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <ChakraProvider value={system}>
        <MsalProvider instance={msalInstance}>
          <SiteContentProvider>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </SiteContentProvider>
        </MsalProvider>
      </ChakraProvider>
    </React.StrictMode>
  );
});
